export default __webpack_public_path__ + "static/media/EG_Zoom-2.6e916ad2.wav";